<template>
    <div class="momoverse">
        <div class="verse-top show-page">
            <div class="t1 bold bounceUpIn">MOMOverse</div>
            <div class="h3 bounceUpIn" style="animation-delay:0.2s">The MOMOverse is a cross platform metaverse that can be enjoyed on all devices no matter where you are.  Whether it is creating content or enjoying others’ creations, the MOMOverse rewards players, developers, and collectors for their engagement and enjoyment.</div>
        </div>

        <div class="pc-contain verse-body show-page">
            <div class="verse-body-left">
                <div class="verse-left-text bounceUpIn" style="animation-delay:0.4s">
                    <transition name="fade">
                        <div v-if="selectIdx==0" class="h3" key="0">{{files[selectIdx].content}}</div>
                        <div v-else-if="selectIdx==1" class="h3" key="1">{{files[selectIdx].content}}</div>
                        <div v-else-if="selectIdx==2" class="h3" key="2">{{files[selectIdx].content}}</div>
                    </transition>
                </div>
                <div ref="imgBox" class="bounceUpIn" style="animation-delay:0.2s">
                    <transition name="slide">
                        <img v-if="selectIdx==0" key="0" class="verse-img" :src="files[0].imgUrl" alt="">
                        <img v-else-if="selectIdx==1" key="1" class="verse-img" :src="files[1].imgUrl" alt="">
                        <img v-else-if="selectIdx==2" key="2" class="verse-img" :src="files[2].imgUrl" alt="">
                    </transition>
                </div>
            </div>
            
            <div class="verse-body-right">
                <ul class="verse-list">
                    <li @click="selectDetail(idx)" v-for="(item, idx) in files" :key="idx">
                        <div class="verse-list-title bounceUpIn" :style="`animation-delay:${getDt(idx)}s`">
                            <div class="list-active" :style="`transform-origin:right center;transform:scale(${selectIdx == idx ? 1 : 0})`"></div>
                            <div class="h1 bold">{{item.title}}</div>
                        </div>
                    </li>
                </ul>
                <img class="pc-state verse-line zoomIn" style="animation-delay:0.2s" src="@/assets/index/momoverse/verseline.png" alt="">
            </div>

        </div>

        <img class="verse-decorate" src="@/assets/index/momoverse/decorate1.png" alt="">
    </div>
</template>

<script>
export default {
    data(){
        return {
            liststart : 0.1,
            listdt : 0.1,

            selectIdx : 0,
            files:[
                {title:`MOMO Avatar`, content:`Dive into the MOMOverse with your first NFT.  MOMO Avatars is who you are in the MOMOverse.  Each Avatar is a unique ERC721 NFT with no two being the same.  `, imgUrl:require(`@/assets/index/momoverse/verse2.png`)},
                {title:`MOMO NFTs`, content:`Farm, battle, and earn with unique NFTs.  MOMOs are cute little creatures that live within the MOMOverse.  Players and catch and own MOMOs and use them in a variety of ways across all the games within the MOMOverse.`, imgUrl:require(`@/assets/index/momoverse/verse3.png`)},
                {title:`Blind Box`, content:`MOBOX Blind Boxes are real life blind boxes that contain unique MOMO figurines with a QR code on each one. Players can scan the QR code and the same unique MOMO is immediately minted on the Binance Smart Chain and used across the MOMOverse.`, imgUrl:require(`@/assets/index/momoverse/verse4.png`)},
            ]
        }
    },

    mounted(){
        this.setImgBoxHeight();
        window.onresize = ()=>{
            this.setImgBoxHeight();
        }
    },

    methods:{
        setImgBoxHeight(){
            // console.log();
            this.$refs.imgBox.style.height = `${0.57*this.$refs.imgBox.offsetWidth}px`;

        },
        selectDetail(idx){
            this.selectIdx = idx;
        },
        getDt(idx){
            return this.liststart + this.listdt*idx
        },
    }
}
</script>

<style lang="less" scoped>
    .momoverse{
        background: url(../../assets/index/momoverse/bg1.png) no-repeat;
        background-size: inherit;
        margin-top: -94px;
        padding-top: 170px;
        position: relative;

        color: white;

        .verse-top{
            text-align : center;

            .h3{
                margin: 40px auto 60px auto;
                max-width: 60%;
            }
        }

        .verse-body{
            display: flex;
            justify-content: space-between;
            align-items: center;

            .verse-body-left{
                width: 50%;
                display: flex;
                flex-direction: column-reverse;
    
                .verse-left-text{
                    margin: 30px 0;
                    height: 131px;
                    overflow: auto;

                    div{
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }
    
                .verse-img{
                    position: absolute;
                    width: 100%;
                }
            }

            .verse-body-right{
                display: flex;

                .verse-list{
                    list-style: none;
                    margin: 0;
                    padding: 0;

                    li{
                        cursor: pointer;
                        margin-bottom: 50px;
                        text-align:right;

                        .verse-list-title{
                            display: inline-block;
                            position: relative;

                            .h1{
                                position: relative;
                            }
                        }

                        .list-active{
                            position: absolute;
                            bottom: 3px;
                            
                            width: 100%;
                            height: 0;
                            border-width: 0px 0 10px 10px;
                            border-style: none solid solid;
                            border-color: transparent transparent #1949C6;

                            transition: 0.3s all;
                        }
                    }

                }

                .verse-line{
                    height: 100%;
                    max-height: 525px;
                    margin-left: 45px;
                }
            }
        }

        .verse-decorate{
            width: 312px;
            position: absolute;
            bottom: -110px;
            right: 0;
            z-index: 1;
        }

    }
</style>